/**
 * Returns a date string formatted in the specified format:
 * - 'full' for "Month Name, Day, Year" - default
 * - a string with `y` representing year, `m' representing month and 'd' representing day
 *   a dingle 'm' or 'd' will not use leading zeros. 'yy' will use last two digits of year
 *   ex: yyyy-mm    --> 2025-06
 *       mm/dd/yyyy --> 12/28/2024
 *       mm/yy      --> 06/25
 *       d-m-yy     --> 4-6-25
 *
 * @param {object\string|null|undefined} date - The input date as either a string or a JS date object
 * @param {string} format - The desired output format
 * @returns {string|null}
 */

const formatDate = (date, format = 'full') => {
  if (!date) return '';
  let dateObj = typeof date === 'string' ? new Date(date) : date;

  let year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  let day = dateObj.getDate();
  if (format === 'full') {
    // Default format 'full': Month Name, Day, Year
    let month = dateObj.toLocaleDateString(undefined, { month: 'long' });
    return `${month} ${day}, ${year}`;
  }

  let string = format;
  const count = (letter) => {
    return (string.match(new RegExp(letter, 'g')) || []).length;
  };

  if (count('m') > 2 || count('d') > 2 || count('y') > 4 || count('y') < 2) {
    console.error('Invalid Date Format Used');
    return '';
  }

  if (count('y') <= 2) year = String(year).slice(2); // only use last 2 digit of year ex: 1994 vs. 94
  if (count('m') > 1) month = String(month).padStart(2, '0'); // use leading zero for single digit months
  if (count('d') > 1) day = String(day).padStart(2, '0'); // use leading zero for single digit dates

  // replace (combined) instances of letter in format string
  string = string.replace(/y+/g, year);
  string = string.replace(/m+/g, month);
  string = string.replace(/d+/g, day);

  return string;
};

export default formatDate;
